import { Chart, registerables } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import zoomPlugin from 'chartjs-plugin-zoom'
import React from 'react'
import { Doughnut } from 'react-chartjs-2'
import { isNumeric } from '../../helpers'

interface Props {
  labels: string[]
  bgColor: string[]
  data: number[]
  width?: number
  height?: number
  responsive: boolean
  hoverLabel?: string
  chartRef?: React.RefObject<any>
  customLegend?: boolean
}

Chart.register(...registerables, ChartDataLabels, zoomPlugin)

export const CustomLegend: React.FC<{
  chartRef: React.RefObject<any>
  className?: string
}> = ({ chartRef, className }) => {
  if (!chartRef.current) return null
  const chart = chartRef.current

  // Safety checks
  if (!chart.data || !chart.data.datasets.length) return null

  const dataset = chart.data.datasets[0]
  const labels = chart.data.labels ?? []

  // total for percentage calc
  const total = dataset.data.reduce((acc: number, val: number) => acc + val, 0)

  return (
    <ul
      style={{ listStyle: 'none', padding: 0 }}
      className={`flex items-center gap-3 text-xs text-sec-black ${className}`}
    >
      {labels.map((label: string, i: number) => {
        const value = dataset.data[i] as number
        const percentage = ((value / total) * 100).toFixed(1)

        const bgColor = Array.isArray(dataset.backgroundColor)
          ? (dataset.backgroundColor[i] as string)
          : 'gray'

        return (
          <li key={i} className="flex items-center lowercase">
            <span
              style={{
                width: 12,
                height: 12,
                backgroundColor: bgColor,
                display: 'inline-block',
                marginRight: 8,
                borderRadius: 3, // rectangle shape
              }}
            />
            {isNumeric(percentage) ? percentage : 0}% {label}
          </li>
        )
      })}
    </ul>
  )
}

const DoughnutChart: React.FC<Props> = ({
  data,
  labels,
  width = 500,
  height = 200,
  bgColor,
  responsive,
  hoverLabel = 'Value',
  chartRef,
  customLegend = false,
}) => {
  return (
    <Doughnut
      ref={chartRef}
      data={{
        labels: labels,
        datasets: [
          {
            label: hoverLabel,
            backgroundColor: bgColor,
            borderColor: bgColor,
            borderWidth: 1,
            data: data,
            hoverBorderColor: 'white',
            hoverBorderWidth: 2,
            hoverOffset: 5,
          },
        ],
      }}
      options={{
        responsive,
        cutout: 80,
        plugins: {
          datalabels: {
            color: 'white',
            formatter: (value: number, context: any) => {
              const data = context.chart.data.datasets[0].data
              const total = data.reduce((a: number, b: number) => a + b, 0)
              const percentage = ((value / total) * 100).toFixed(1)
              return `${percentage}%`
            },
            font: {
              size: 0,
              weight: 500,
            },
          },
          legend: {
            display: !customLegend,
            position: 'bottom',
            labels: {
              color: '#7A7978',
              borderRadius: 5,
              boxWidth: 12,
              boxHeight: 12,
              useBorderRadius: true,
              pointStyle: 'rectRounded',
              usePointStyle: true,
              // generateLabels: (chart) => {
              //   const dataset = chart.data.datasets[0]
              //   const total = dataset.data.reduce(
              //     (sum, value) => (sum as number) + ((value ?? 0) as number),
              //     0,
              //   )
              //   const originalLabels = chart.data.labels

              //   return (
              //     originalLabels?.map((label, i) => {
              //       const value = dataset.data[i]
              //       const percentage = (
              //         (((value as number) ?? 0) / ((total as number) ?? 1)) *
              //         100
              //       ).toFixed(1)

              //       return {
              //         text: `${percentage}% ${label}`, // prefix or change the label text
              //         fillStyle: Array.isArray(
              //           chart.data.datasets[0].backgroundColor,
              //         )
              //           ? chart.data.datasets[0].backgroundColor[i]
              //           : undefined,
              //         hidden: false,
              //         index: i,
              //         strokeStyle: undefined,
              //         lineWidth: 0,
              //         pointStyle: 'rectRounded',
              //         color: '#7A7978',
              //       }
              //     }) ?? []
              //   )
              // },
            },
          },
        },
      }}
      width={width}
      height={height}
    />
  )
}

export default DoughnutChart
